// Redux
import { createSlice } from '@reduxjs/toolkit'

export type PageList =
  | 'global'
  | 'applications'
  | 'creditNotes'
  | 'dayworks'
  | 'deliveryNotes'
  | 'directCosts'
  | 'goodsReturnNotes'
  | 'invoices'
  | 'invoiceChecking'
  | 'paymentNotices'
  | 'projects'
  | 'purchaseOrders'
  | 'variations'

export type TableDensity = 'compact' | 'normal' | 'comfortable'

export type LayoutView = 'grid' | 'list'

type ViewState = {
  global: LayoutView
  applications: LayoutView
  creditNotes: LayoutView
  dayworks: LayoutView
  deliveryNotes: LayoutView
  directCosts: LayoutView
  goodsReturnNotes: LayoutView
  invoices: LayoutView
  invoiceChecking: LayoutView
  paymentNotices: LayoutView
  projects: LayoutView
  purchaseOrders: LayoutView
  variations: LayoutView

  tableDensity?: TableDensity
  tableOptions?: boolean
}

const initialState: ViewState = {
  global: 'grid',
  applications: 'grid',
  creditNotes: 'grid',
  dayworks: 'grid',
  deliveryNotes: 'grid',
  directCosts: 'grid',
  goodsReturnNotes: 'grid',
  invoices: 'grid',
  invoiceChecking: 'grid',
  paymentNotices: 'grid',
  projects: 'grid',
  purchaseOrders: 'grid',
  variations: 'grid',

  tableDensity: 'normal',
  tableOptions: false,
}

const view = createSlice({
  name: 'view',
  initialState,
  reducers: {
    setLayout(
      state,
      action: {
        payload: {
          page: PageList
          layout: LayoutView
        }
      },
    ) {
      const { page, layout } = action.payload

      state[page] = layout
    },
    setTableDensity(
      state,
      action: {
        payload: TableDensity
      },
    ) {
      state.tableDensity = action.payload
    },
    toggleTableOptions(state) {
      state.tableOptions = !state.tableOptions
    },
    resetLayouts(state) {
      Object.entries(state).forEach(([key, value]) => {
        if (key !== 'tableDensity') {
          state[key as PageList] = 'grid'
        }
      })
    },
  },
})

export type TViewState = ViewState

export default view.reducer

export const { setLayout, setTableDensity, toggleTableOptions, resetLayouts } = view.actions

export const getLayoutAction = (page: PageList, layout: LayoutView) => {
  return setLayout({ page, layout })
}
